import { jsx } from 'react/jsx-runtime';
import { Box } from '../Box/index.js';

var Divider = function (_a) {
    var _b = _a.orientation, orientation = _b === void 0 ? "horizontal" : _b;
    return (jsx(Box, { component: "span", sx: {
            display: "block",
            width: orientation === "vertical" ? "1px" : "100%",
            height: orientation === "horizontal" ? "1px" : "100%",
            backgroundColor: "black.10",
        } }));
};
Divider.displayName = "Divider";

export { Divider };
//# sourceMappingURL=Divider.js.map
